const curryConnector = (connector, STATE_KEY) => (state, ...args) => connector({ localState: state[STATE_KEY], state }, ...args);
export default curryConnector;
